import { Toast } from '@collab/features/toasts';

export const fetchUserError =
  'We could not load your profile right now. Please try again later.';

export const fetchUserErrorToast: Toast = {
  text: fetchUserError,
  key: 'fetch-user',
};
